(function () {
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
    return;
  }
  gsap.registerPlugin(ScrollTrigger);

  var containers = document.querySelectorAll(".cew-parallax-container");
  if (!containers || !containers.length) {
    return;
  }

  containers.forEach(function (container) {
    var image = container.querySelector(".cew-parallax-image");
    if (!image) {
      return;
    }

    var toPx = function (value) {
      if (typeof value === "number") return value;
      if (!value) return 0;
      var v = String(value).trim();
      if (v.endsWith("vh")) {
        var numVh = parseFloat(v);
        return isNaN(numVh) ? 0 : (window.innerHeight * numVh) / 100;
      }
      if (v.endsWith("px")) {
        var numPx = parseFloat(v);
        return isNaN(numPx) ? 0 : numPx;
      }
      var num = parseFloat(v);
      return isNaN(num) ? 0 : num;
    };

    var setup = function () {
      var imgHeight = image.offsetHeight || image.clientHeight || 0;
      if (!imgHeight) {
        setTimeout(setup, 100);
        return;
      }

      var yDistance = 0;
      var hasNoTopOffset = container.classList.contains(
        "cew-parallax-no-top-offset"
      );
      var defaultMin = "50vh";
      var defaultMinNoTop = "25vh";

      // Pobierz min-height z CSS custom property; najpierw z kontenera, potem z .brxe-section
      var minSourceStyle = window.getComputedStyle(container);
      var minHeight =
        minSourceStyle.getPropertyValue("--image-min-height") || "";

      if (!minHeight || minHeight.trim() === "") {
        var sectionEl = container.querySelector(".brxe-section");
        if (sectionEl) {
          minSourceStyle = window.getComputedStyle(sectionEl);
          minHeight =
            minSourceStyle.getPropertyValue("--image-min-height") || "";
        }
      }

      var cleanMin =
        minHeight && minHeight.trim() !== ""
          ? minHeight.trim()
          : hasNoTopOffset
          ? defaultMinNoTop
          : defaultMin;

      var baseMin = cleanMin;
      var translateValue = hasNoTopOffset
        ? "calc(".concat(baseMin, " / 2)")
        : baseMin;

      var translatePx = toPx(hasNoTopOffset ? baseMin : baseMin);
      if (hasNoTopOffset) {
        translatePx = translatePx / 2;
      }

      image.style.minHeight = "calc(100vh + ".concat(baseMin, ")");
      yDistance = translatePx;

      var scrollStart = hasNoTopOffset ? "top top" : "top top";
      var scrollEnd = hasNoTopOffset
        ? "+=".concat(imgHeight, "px")
        : "bottom bottom";

      var scaleAttr = parseFloat(image.getAttribute("data-parallax-scale"));
      var baseScale = !isNaN(scaleAttr) && scaleAttr > 0 ? scaleAttr : 1.1;
      var scale = hasNoTopOffset ? 1 + (baseScale - 1) / 2 : baseScale;
      gsap.to(image, {
        y: yDistance,
        scale: scale,
        ease: "none",
        scrollTrigger: {
          trigger: container,
          start: scrollStart,
          end: scrollEnd,
          scrub: true,
          markers: false,
        },
      });
    };

    if (image.complete) {
      setup();
    } else {
      image.addEventListener("load", setup, { once: true });
    }
  });
})();
